import { Box, Text } from '@chakra-ui/react'
import { type FC, memo } from 'react'

import ImportPropertyMetricsButton from './importPropertyMetricsButton'

import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import { CardHeader } from '@app/shared/layout'
import Table from '@app/shared/table'
import type { Column } from '@app/shared/table/types'
import type { GoogleIntegration, Integration } from '@graphql/types'

type Props = {
  integration: Pick<GoogleIntegration, 'activitiesCount' | 'propertiesV4'>
}

const PropertyCell = ({ data: property }) => (
  <Text key={property.id}>
    {property.display_name} ({property.id})
  </Text>
)

const ActionCell = ({ integration, data: property }) => {
  const { formatDateTimeInUserTimeZone } = useStoreCurrentUser()
  const propertyImports = integration?.propertyImports || {}
  const importedAt = propertyImports[property.id]
  let action

  if (importedAt) {
    action = <Text>Imported on {formatDateTimeInUserTimeZone(importedAt)}</Text>
  } else {
    action = <ImportPropertyMetricsButton integration={integration} property={property} />
  }

  return <Box textAlign="right">{action}</Box>
}

const columns = (integration): Column<Integration>[] => [
  {
    header: 'Property',
    cell: PropertyCell
  },
  {
    header: '',
    cell: ({ data }) => <ActionCell integration={integration} data={data} />
  }
]

const PropertyImports: FC<Props> = ({ integration }) => {
  const properties = integration?.propertiesV4 || []

  if (properties.length === 0) {
    return null
  }

  return (
    <Box p={4}>
      <CardHeader title="Google Analytics Properties" />
      <Table mt={4} columns={columns(integration)} data={properties} />
    </Box>
  )
}

export default memo(PropertyImports)
